import { render } from "./Terms.vue?vue&type=template&id=093cd4ce&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=093cd4ce&scoped=true&lang=scss"
import "./Terms.vue?vue&type=style&index=1&id=093cd4ce&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093cd4ce"]])

export default __exports__